import { render, staticRenderFns } from "./shopView.vue?vue&type=template&id=5a01dbe6&scoped=true"
import script from "./shopView.vue?vue&type=script&lang=js"
export * from "./shopView.vue?vue&type=script&lang=js"
import style0 from "./shopView.vue?vue&type=style&index=0&id=5a01dbe6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a01dbe6",
  null
  
)

export default component.exports